"use client";

import type { ConvexApiModule } from "@packages/confect/rpc";
import type { ClawyTasksModule } from "@packages/database/convex/rpc/clawyTasks";
import { anyApi } from "convex/server";
import { createRpcModuleClientContext } from "./client-context";

// The module type parameter carries all client typing; the runtime argument
// only supplies function paths. anyApi avoids instantiating the generated
// api object's type, which forces TypeScript to type every Convex module at
// once and trips TS2589. The module path is pinned by the database package's
// fnRefPaths.test.ts.
const moduleRef = (
	anyApi as unknown as { rpc: { clawyTasks: ConvexApiModule } }
).rpc.clawyTasks;

export const {
	RpcClientProvider: ClawyTasksProvider,
	useRpcClient: useClawyTasks,
} = createRpcModuleClientContext<ClawyTasksModule>(moduleRef);
